import {batch, computed, signal} from "@preact/signals-react";


export const reverseMatcherItems = signal(null)
export const reverseMatcherImageSize = signal(1)
export const isLoadMoreItems = signal(false)
export const reverseMatcherImageComparatorModalData = signal({})
export const reverseMatcherGroupBy = signal(null) // null | 'reference' | 'productURL'
export const reverseMatcherBatchGroupBy = signal(null) // inherited from batch (read-only)
export const reverseMatcherGroupedProductIDs = signal([]) // additional product IDs from the selected group

// Computed
export const isReverseMatcherLoading = computed(() => reverseMatcherItems.value === null)
export const reverseMatcherImageSizeValue = computed(() => [150, 200, 250][reverseMatcherImageSize.value])

// Functions
export const clearReverseMatcherSignals = () => batch(() => {
	reverseMatcherItems.value = null
	reverseMatcherImageSize.value = 1
	isLoadMoreItems.value = false
	reverseMatcherImageComparatorModalData.value = {}
	reverseMatcherGroupBy.value = null
	reverseMatcherBatchGroupBy.value = null
	reverseMatcherGroupedProductIDs.value = []
})